import { Switch } from "@/components/ui/switch";

interface SectionHeaderProps {
  title: string;
  sectionName: string;
  isVisible: boolean;
  onToggle: (sectionName: string) => void;
}

export const SectionHeader = ({ 
  title, 
  sectionName, 
  isVisible, 
  onToggle 
}: SectionHeaderProps) => (
  <div className="flex items-center justify-between mb-4">
    <h2 className="text-2xl font-semibold">{title}</h2>
    <div className="flex items-center gap-2">
      <span className="text-sm text-muted-foreground">
        {isVisible ? "Visible" : "Hidden"}
      </span>
      <Switch
        checked={isVisible}
        onCheckedChange={() => onToggle(sectionName)}
      />
    </div>
  </div>
);